<template>
    <div>
        <el-tabs v-model="activeName"  type="border-card">
            <el-tab-pane label="周事周毕" name="0">
                <cooperateForm :sectionClassId="9"></cooperateForm>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import cooperateForm from '@/components/cooperative/cooperativeForm'

    //定义组件
    export default {
        data() {
            return {
                activeName:'0'
            }
        },
        components:{
            cooperateForm

        },
    }
</script>


// WEBPACK FOOTER //
// src/views/cooperative/weekafterweek.vue